export const GAMES = [
  {
    id: 'wordle',
    name: '5 букв',
    icon: '🔤',
    path: '/game',
    shortDescription: 'Угадай слово из 5 букв за 6 попыток',
    reward: '5 SHC за каждую победу (до 3 побед в день)',
    rules: [
      'Загадано случайное слово из 5 букв русского алфавита.',
      'У вас есть 6 попыток, чтобы его угадать.',
      'После каждой попытки буквы подсвечиваются:',
      '🟩 зелёный — буква на своём месте',
      '🟨 жёлтый — буква есть в слове, но не на том месте',
      '⬜ серый — такой буквы в слове нет',
    ],
    conditions: [
      'Новый день — новое слово.',
      'Максимум 3 победы в день — каждая приносит 5 SHC на баланс.',
      'SHC можно потратить до 100% стоимости любого заказа (роллы, сеты и любая другая продукция).',
    ],
  },
];
